import { useState, useEffect, useCallback } from "react";
import { getCurrentUser } from "../../../../store/instanceManagement/instanceService";

interface CurrentUser {
  fullname: string;
  email: string;
  isPlatformAdmin: boolean;
  lastLogin?: string;
  [key: string]: unknown;
}

interface UseCurrentUserReturn {
  currentUser: CurrentUser | null;
  initials: string;
  isLoaded: boolean;
  refresh: () => void;
}

function getInitials(fullname: string): string {
  if (!fullname) return "";
  const parts = fullname.trim().split(/\s+/);
  if (parts.length === 1) {
    return parts[0].substring(0, 2).toUpperCase();
  }
  return (parts[0][0] + parts[parts.length - 1][0]).toUpperCase();
}

export function useCurrentUser(): UseCurrentUserReturn {
  const [currentUser, setCurrentUser] = useState<CurrentUser | null>(null);
  const [isLoaded, setIsLoaded] = useState<boolean>(false);

  const fetchUser = useCallback(async () => {
    setIsLoaded(false);
    try {
      const data = await getCurrentUser();
      setCurrentUser(data);
    } catch (error) {
      console.error("Failed to get current user", error);
    } finally {
      setIsLoaded(true);
    }
  }, []);

  useEffect(() => {
    fetchUser();
  }, [fetchUser]);

  return {
    currentUser,
    initials: getInitials(currentUser?.fullname || ""),
    isLoaded,
    refresh: fetchUser,
  };
}
